import { Component, Input, TemplateRef, HostBinding, ViewChild, ElementRef } from '@angular/core';
import { NavigationService, WafFormHelper } from '../../../../modules/tcm-core.module';
import { ModalButtonDescriptor } from '../../models/modal-button-descriptor';
import { NgForm } from '@angular/forms';

@Component({
    selector: 'tcm-message-modal',
    templateUrl: './tcm-message-modal.component.html',
    styleUrls: ['./tcm-message-modal.component.scss', './modal-message-types.scss'],
    standalone: false
})
export class TcmMessageModalComponent implements TcmMessageModal {

    @Input()
    title: string;

    @Input()
    content: string;

    @Input()
    template: TemplateRef<any>;

    @Input()
    templateData: any;

    @Input()
    buttons: ModalButtonDescriptor<any>[];

    @HostBinding('class')
    messageType: string;


    @ViewChild(NgForm) 
    private readonly ngForm: NgForm;

    @ViewChild(NgForm, { read: ElementRef })
    private ngFormElementRef: ElementRef;

    constructor(private navigationService: NavigationService) {
    }

    closeExternal = (value?: any) => {
        this.navigationService.navigateBack(value);
    };

    closeModal(event: Event) {
        event.stopPropagation();

        const defaultButton = this.buttons.find(x => x.isDefault === true);

        this.navigationService.navigateBack(defaultButton ? defaultButton.value : null);
    }

    executeAction(event: Event, button: ModalButtonDescriptor<any>) {
        event.stopPropagation();

        if (button.requireValidForm === true && !this.ngForm.valid) {
            WafFormHelper.invalidateForm(this.ngForm, this.ngFormElementRef.nativeElement, true);
            return;
        }

        this.navigationService.navigateBack(button.value);
    }
}

export interface TcmMessageModal {

    title: string;

    content: string;

    template: TemplateRef<any>

    templateData: any;

    buttons: ModalButtonDescriptor<any>[];

    messageType: string;
}